export function dataInRequest(params = {}) {
  return {
    type: '@modeloEquipamento/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@modeloEquipamento/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@modeloEquipamento/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@modeloEquipamento/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@modeloEquipamento/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@modeloEquipamento/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@modeloEquipamento/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@modeloEquipamento/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@modeloEquipamento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@modeloEquipamento/RECORD_FILTERING',
    payload: { params },
  };
}
